<template>
  <el-dialog
    class="item-source-detail-modal"
    width="90%"
    title="货源详情"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div class="section">
      <div class="title">货源明细</div>
      <data-table :columns="columns" :list="list" />
    </div>
    <div v-if="itemFlows && itemFlows.length" class="section">
      <div class="title">跟踪记录</div>
      <div class="ctx source-flows">
        <div v-for="(flow, index) in itemFlows" :key="index" class="flow">
          <div class="time">{{ flow.createTime | dateTimeFmt }}</div>
          <div class="content">{{ flow.content }}<span class="creator">(操作人:{{ flow.creator }})</span></div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import DataTable from '@/components/DataTable'
import { LoadSourceInfoByOrderItem } from '../services'
import moment from 'moment'
export default {
  name: 'OrderItemSeouceDetailModal',
  components: { DataTable },
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      list: [],
      itemFlows: [],
      orderItem: {
        id: undefined,
        partCode: '',
        supersession: '',
        brandCode: '',
        quantity: 0,
        quantityReturn: 0,
        quantityDelivered: 0,
        warehouse: '',
        partName: ''
      },
      columns: [
        {
          name: '货源数量',
          code: 'quantity',
          flexWidth: 1
        },
        {
          name: '货源类型',
          code: 'sourceType',
          flexWidth: 1,
          renderFunc (val) {
            return ['', '本仓现货', '外仓调拨', '本地采购', '异地采购'][val] || ''
          }
        },
        {
          name: '货源',
          code: 'source',
          flexWidth: 2,
          cellComponent: {
            template: `
              <ellipsis-text :content="row.source">{{ row.source }}</ellipsis-text>
            `
          }
        },
        {
          name: '入库门店',
          code: 'warehouse',
          flexWidth: 1
        },
        {
          name: '计划/实际采购时间',
          code: 'timeForPurchase',
          flexWidth: 1.6,
          cellComponent: {
            template: `
              <div>
                <div>{{ row.timeForPurchase }}</div>
                <div>{{ row.timeForPurchaseActual }}</div>
              </div>
            `
          }
        },
        {
          name: '计划/实际入库时间',
          code: 'timeForLading',
          flexWidth: 1.6,
          cellComponent: {
            template: `
              <div>
                <div>{{ row.timeForLading }}</div>
                <div>{{ row.timeForLadingActual }}</div>
              </div>
            `
          }
        },
        {
          name: '计划/实际调拨时间',
          code: 'timeForAllocate',
          flexWidth: 1.6,
          cellComponent: {
            template: `
              <div>
                <div>{{ row.timeForAllocate }}</div>
                <div>{{ row.timeForAllocateActual }}</div>
              </div>
            `
          }
        },
        {
          name: '计划/实际到货时间',
          code: 'timeForArrival',
          flexWidth: 1.6,
          cellComponent: {
            template: `
              <div>
                <div>{{ row.timeForArrival }}</div>
                <div>{{ row.timeForArrivalActual }}</div>
              </div>
            `
          }
        },
        {
          name: '状态',
          code: 'state',
          flexWidth: 1,
          cellComponent: {
            template: `
              <div :style="{ color: row.state === -1 ? '#d9001b' : row.state === 5 ? '#229142' : row.state === 6 ? '#8400ff' : '#4675e7' }">
                <div>
                  <div>
                    {{
                      (
                        {
                          '-1':'已取消',
                          '1':'待采购',
                          '2':'采购中',
                          '3':'待调拨',
                          '4':'调拨中',
                          '5':'已到货',
                          '6': '索赔中'
                        }[row.state.toString()]
                      ) || '--' 
                    }}
                  <el-popover v-if="row.flows && row.flows.length" trigger="hover" placement="top-end" width="600">
                    <i slot="reference" class="el-icon-info"></i>
                    <div class="ctx source-flows">
                      <div v-for="flow in row.flows" :key="flow.id" class="flow">
                        <div class="time">{{ flow.createTime | dateTimeFmt }}</div>
                        <div class="content">{{ flow.content }}<span class="creator">(操作人:{{ flow.creator }})</span></div>
                      </div>
                    </div>
                  </el-popover>
                  </div>
                  <div v-if="row.state === 6" :style="{ color: '#f59a23' }">
                    ({{
                      (
                        {
                          '-1': '已取消',
                          '1': '待确认',
                          '2': '核验中',
                          '3': '待退货',
                          '4': '索赔中',
                          '5': '待入库',
                          '6': '索赔失败',
                          '7': '以换货',
                          '8': '已退货'
                        }[row.claimState.toString()]
                      ) || '--'
                    }})
                  </div>
                </div>
              </div>
            `
          }
        }
      ]
    }
  },
  methods: {
    init (orderItem) {
      this.getItemSourceDetail(orderItem.id)
      this.orderItem = orderItem
      return this.open()
    },
    getItemSourceDetail (orderItemId) {
      this.loading = true
      LoadSourceInfoByOrderItem(orderItemId).then((ans) => {
        const { sources, sourceFlows, itemFlows } = ans || {};
        (sources || []).forEach(item => {
          item.flows = sourceFlows.filter(t => t.orderItemSourceId === item.id)
          item.timeForPurchase = item.sourceType === 2 ? '' : (item.timeForPurchase ? moment(item.timeForPurchase).format('YYYY-MM-DD HH:mm') : '')
          item.timeForPurchaseActual = item.sourceType === 2 ? '' : (item.timeForPurchaseActual ? moment(item.timeForPurchaseActual).format('YYYY-MM-DD HH:mm') : '--')
          item.timeForLading = item.sourceType === 2 ? '' : (item.timeForLading ? moment(item.timeForLading).format('YYYY-MM-DD') : '')
          item.timeForLadingActual = item.sourceType === 2 ? '' : (item.timeForLadingActual ? moment(item.timeForLadingActual).format('YYYY-MM-DD') : '--')
          item.timeForAllocate = item.timeForAllocate ? moment(item.timeForAllocate).format('YYYY-MM-DD') : ''
          item.timeForAllocateActual = item.timeForAllocate ? (item.timeForAllocateActual ? moment(item.timeForAllocateActual).format('YYYY-MM-DD') : '--') : ''
          item.timeForArrival = item.timeForArrival ? moment(item.timeForArrival).format('YYYY-MM-DD') : ''
          item.timeForArrivalActual = item.timeForArrival ? (item.timeForArrivalActual ? moment(item.timeForArrivalActual).format('YYYY-MM-DD') : '--') : ''
        })
        this.list = sources || []
        this.itemFlows = itemFlows || []
      }).catch(() => {
        this.$message.error('加载货源信息失败')
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.item-source-detail-modal
  .el-dialog
    max-width 1024px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      .title
        font-size 16px
        font-weight bold
        padding 8px 0
      .base-data-table
        td
          text-align center
</style>
